// extracted by mini-css-extract-plugin
export default {"CloseBtn":"gateSettingsCloseBtn_CloseBtn__l+mYe"};